export default class MenuTabs {
  constructor() {
    this.navBarPrimary = $('.navbar-primary');
    this.menu = $('.menu-primary');
    this.metaMenu = $('#menu-meta');
    this.back = $('.tab-slideback');
    this.context = $('.tab-context');
    this.meta = $('.menu-meta-wrap');

    this.submenuVisible = false;
    this.current = null;

    this.initMainMenu();
    this.initMetaMenu();
    return this;
  }

  initMainMenu() {
    const $menuItem = $('> .menu-item-has-children > a', this.menu);
    const $back = $('.tab-slideback');

    // Run once
    this.preventTabOverflow();

    $menuItem.off().on('click', (e) => {
      e.preventDefault();
      this.slideFurther(e);
      this.update();
    });
    $back.off().on('click', (e) => {
      e.preventDefault();
      this.slideBack(e);
      this.update();
    });
  }

  initMetaMenu() {
    const menuItems = $('.menu-item-has-children > a', this.metaMenu);

    menuItems.off();

    menuItems.off().on('click', (e) => {
      e.preventDefault();

      const link = $(e.currentTarget);
      const listItem = link.parent();
      const subMenu = link.next('.sub-menu');

      listItem.toggleClass('open');
      subMenu.slideToggle();
    });
  }

  slideFurther(e) {
    const $target = $(e.currentTarget);
    const margin = this.getCurrentTabMargin();

    $target.parent().parent().addClass(`level-${margin}-on-display`);
    this.current = $target.parent().find('.sub-menu').eq(0);
    this.current.addClass('menu-item-open-submenu');

    this.navBarPrimary.addClass('deeper-level-on-display');

    this.menu.css({
      marginLeft: `${margin - 100}%`,
    });
  }

  slideBack() {
    const margin = this.getCurrentTabMargin();
    const marginDepth = new Map([
      [-100, 0],
      [-200, 1],
      [-300, 2],
    ]);

    const currentLevel = marginDepth.get(margin);

    this.menu.removeClass(`level-${currentLevel}-on-display`);

    if (currentLevel === 0) {
      this.navBarPrimary.removeClass('deeper-level-on-display');
    }

    if (margin < 0) {
      this.menu.css({
        marginLeft: `${margin + 100}%`,
      });
    }

   
    this.current.removeClass('menu-item-open-submenu');
  }

  update() {
    this.preventTabOverflow();
    this.setCurrentTabContext();
    this.setMobileMenuHeight();
    this.hideMeta();
  }

  getCurrentTabMargin() {
    if (this.menu.length && this.menu[0].style.marginLeft) {
      return Number.parseInt(this.menu[0].style.marginLeft, 10);
    }

    return 0;
  }

  setMobileMenuHeight() {
    const submenu = $('.menu-item-open-submenu', this.menu).last();
    let newHeight = submenu.height();

    if (!this.initialHeight) {
      this.initialHeight = this.menu.height();
    }

    if (newHeight == null) {
      newHeight = this.initialHeight;
    }

    this.menu.height(newHeight);
  }

  preventTabOverflow() {
    const margin = this.getCurrentTabMargin();

    if (margin === 0) {
      this.submenuVisible = false;
    } else {
      this.submenuVisible = true;
    }
  }

  /**
   * Shows the user what menu item the current submenu belongs to
   */
  setCurrentTabContext() {
    const parent = $('.menu-item-open-submenu').last().parents('.menu-item-has-children').eq(0);
    const contextHolder = $('.menu-item-open-submenu').last();

    if (contextHolder.length) {
      this.context = this.context.prependTo(contextHolder);
      this.context.toggleClass('visible', this.submenuVisible);

      $('.context-text', this.context).text($('> .nav-link', parent).text());
      $('.context-description', this.context).text($('> .menu-item-description', parent).text());

      $('a.nav-link', this.context).attr('href', $('> .nav-link', parent).attr('href'));
    }
  }

  hideMeta() {
    this.meta.toggle(!this.submenuVisible);
  }

  /**
   * Makes clicking the menu possible again
   * without trying to slide it out of the user's view
   */
  destroy() {
    const $menuItem = $('> .menu-item-has-children > a', this.menu);
    const $back = $('.tab-slideback');

    $menuItem.off();
    $back.off(); // lol
  }
}
